import React from 'react';

// Components
const Footer = () => (
  <footer className="footer">
    <p>Copyright 2025 © BST - Business Software Technology</p>
  </footer>
);

export default Footer;